<widget data-testid="circulation-vcc-widget" title="VCC Status" [subTitle]="'Shows the distribution of activated and outdated VCCs.'+ (dateFilterText | async)">
  <div data-testid="circulation-vcc-chart-wrap" class="widget-chart-wrap" widgetContent>
    <div *ngIf="isLoading" id="circulation-vcc-loading" class="loading-container">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Loading chart data...</span>
    </div>

    <div *ngIf="isError && !isLoading" id="circulation-vcc-error" class="error-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>

    <chart *ngIf="!isLoading && !isError && dataCirculation" data-testid="circulation-vcc-chart"
      [dataSet]="dataCirculation"
      [chartType]="'bar'"
      (chartClick)="navigateToIssueVccPage($event)"
      [options]="circulationVccChartOptions">
    </chart>

    <div *ngIf="!isLoading && !isError && (!dataCirculation || (dataCirculation.labels && dataCirculation.labels.length === 0))" id="circulation-vcc-empty" class="empty-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>
  </div>
</widget>